import { ArrowLeft, Close } from '@zoomit/icons';
import { Image } from '@zoomit/primitives';
import { cn, Flex, Link } from '@zoomit/primitives';
import { Button, Typography } from '@zoomit/zoomit-ds';

import { BaseMediaUrl } from '../../constants/apis';
import { isMobile } from '../../constants/media-query';
import type { OverlaysGetResponse } from '../../types/overlays';

type Props = {
  data: OverlaysGetResponse['overlay'];
  handleClose: () => void;
  handleNavigate: () => void;
};

export const LargeTemplate = (props: Props) => {
  const { data, handleClose, handleNavigate } = props;
  return (
    <div
      data-testid="large-template"
      className="fixed top-0 left-0 z-[100] flex h-full w-full items-center justify-center backdrop-blur-md backdrop-brightness-30"
    >
      <div
        data-testid="large-template-overlay"
        onClick={handleClose}
        className="absolute top-0 left-0 h-full w-full"
      />
      <div className="bg-background1 relative mx-auto w-[calc(100%-32px)] p-0 *:text-white md:w-[616px]">
        <Button
          className="bg-background1 absolute top-0 left-0 z-[2] flex h-6 w-6 -translate-[50%] cursor-pointer items-center justify-center rounded-full border-none p-0 outline-0 md:h-8 md:w-8"
          onClick={handleClose}
          aria-label="Close overlay"
        >
          <Close className="fill-text" />
        </Button>
        <div className="flex flex-col">
          <Link href={data.url} onClick={handleNavigate} target="_blank" rel="noopener noreferrer">
            <div className="relative aspect-3/2 w-full">
              <Image
                alt={data.image.alt || `overlay-${data.title}`}
                src={`${BaseMediaUrl}/${data.image.id}`}
                fill
                className="object-cover"
              />
            </div>
          </Link>
          {(data.title || data.description || data.buttonDescription) && (
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              gap={0.8}
              className="p-4 text-center"
            >
              {data.title && (
                <Link href={data.url} onClick={handleNavigate} target="_blank" rel="noopener noreferrer">
                  <Typography className="font-primary text-h5 md:text-h2 cursor-pointer">
                    {data.title}
                  </Typography>
                </Link>
              )}
              {data.description && (
                <Typography className="text-body md:text-h5 cursor-default leading-7" fontWeight="normal">
                  {data.description}
                </Typography>
              )}
              {data.buttonDescription && (
                <Link href={data.url} onClick={handleNavigate} target="_blank" rel="noopener noreferrer">
                  <Button variant="contained" className="w-fit">
                    <Typography variant="subhead-bold" className="line-clamp-1 text-white">
                      {data.buttonDescription}
                    </Typography>
                    <ArrowLeft className="fill-primary1" />
                  </Button>
                </Link>
              )}
            </Flex>
          )}
        </div>
      </div>
    </div>
  );
};
